interface MapPointLocationOptions {
    blocking?: boolean;
    cancel?: boolean;
    message?: string;
}

export class MapPointLocation extends EventTarget {

    static currentOp: MapPointLocation | null;

    //private currentOpSetter: any;
    //private currentOp: any;
    private options: MapPointLocationOptions = {blocking: false, cancel: true, message: 'kliknij gdzieś'};
    private pointOnMapBar: HTMLDivElement;
    private pointOnMapListener: any;
    private cancelButton: HTMLSpanElement|null = null;

    constructor() {
        super();
        //MapPointLocation.currentOpSetter = mapCurrentSetCoordinateOp.subscribe((function(v: any) { MapPointLocation.currentOp = v; }).bind(this));
        this.pointOnMapBar = document.createElement('div');
        this.pointOnMapBar.style.cssText = 'width: 100%; height: 30px; background-color: #70a0ff; text-align: center; line-height: 30px;';
    }

    public start(options: MapPointLocationOptions): boolean {
        // po przeładowaniu mapy (zmiana języka) globalne Targeo jest chwilowo wyzerowane
        // @ts-ignore Targeo global
        if (typeof Targeo === 'undefined' || !Targeo.Base?.Map) {
            console.error('MapPointLocation.start: Targeo is not defined');
            return false;
        }
        if (!MapPointLocation.currentOp || !MapPointLocation.currentOp.isBlocking()) {
            if (MapPointLocation.currentOp) {
                MapPointLocation.currentOp.close(false);
            }
            this.options = Object.assign(this.options, options);
            this.pointOnMapBar.innerHTML = this.options.message || '';
            if (this.options.cancel) {
                this.cancelButton = document.createElement('span');
                this.cancelButton.style.cssText = 'display: inline-block; background-color: #555555; border-radius: 3px; padding: 5px; color: #ffffff; cursor: pointer; max-height: 18px;line-height: 18px;';
                this.cancelButton.innerHTML = 'anuluj';
                this.pointOnMapBar.appendChild(this.cancelButton);
                this.cancelButton.addEventListener('click', this.close.bind(this, true));
            }
            Targeo.Base.Map.modules.Controls.addControl('point-location', this.pointOnMapBar, {align: 'bottom-left', edge: true, visibilityPriority: 1000, attractPriority: 1000});
            this.pointOnMapListener = Targeo.Base.Map.listenOnce('onClick', (function(evt: any) {
                console.log('!!! listener', evt.coords);
                this.dispatchEvent(new CustomEvent('setCoordinates', {detail: {coords: evt.coords}}));
                this.close(true);
            }).bind(this));
            MapPointLocation.currentOp = this;
            return true;
        }
        return false;
    }

    public close(removeControl: boolean): boolean {
        // @ts-ignore Targeo global
        if (typeof Targeo === 'undefined' || !Targeo.Base?.Map) {
            console.error('MapPointLocation.close: Targeo is not defined');
            this.pointOnMapListener = null;
            if (MapPointLocation.currentOp == this) {
                MapPointLocation.currentOp = null;
            }
            // konsumenci resetują swój tryb "wskaż punkt na mapie" dopiero po zdarzeniu close,
            // więc musi polecieć także wtedy, gdy mapy już nie ma
            this.dispatchEvent(new CustomEvent('close'));
            return false;
        }
        if (this.pointOnMapListener) {
            if (removeControl) {
                Targeo.Base.Map.modules.Controls.removeControl('point-location');
            }
            Targeo.Base.Map.unlistenByKey(this.pointOnMapListener);
            this.pointOnMapListener = null;
            if (MapPointLocation.currentOp == this) {
                MapPointLocation.currentOp = null;
            }
            this.dispatchEvent(new CustomEvent('close'));
            return true;
        }
        return false;
    }

    public isBlocking(): boolean {
        return this.options.blocking || false;
    }

    public isCurrent() {
        return MapPointLocation.currentOp == this;
    }

}